// アプリからのアクセスかどうかを判定する関数
export const isAppAccess = () => {
  const userAgent = navigator.userAgent;
  return userAgent.includes('TetsuryokuApp');
};